<template>
  <b-container fluid id="feature-banner" v-if="featureBanner && planDetails">
    <b-form v-on:submit.prevent>
      <b-row no-gutters>
        <b-col md="8">
          <div class="main">
            <div class="toolbar">
              <div class="arrow">
                <router-link to="/design/estorebanner">
                  <img src="@/assets/images/actions/arrow-back.svg" alt />
                </router-link>
              </div>
              <div class="title">
                <span>Edit Banner Image</span>
              </div>
              <div class="buttons mr-3">
                <b-button
                  type="submit"
                  variant="primary"
                  class="invert mr-2"
                  @click="updateDesign('draft')"
                >
                  <template v-if="loading">Saving...</template>
                  <template v-else>Save Draft</template>
                </b-button>
                <b-button
                  type="submit"
                  variant="primary"
                  v-bind:disabled="loading"
                  @click="updateDesign('publish')"
                  class="primary"
                >
                  <template v-if="loading">Publishing...</template>
                  <template v-else>Publish</template>
                </b-button>
              </div>
            </div>
            <div class="switch-container">
              <span>Guides</span>
              <switches
                v-model="guides"
                theme="custom"
                color="primary"
                type-bold="true"
                text-enabled="On"
                text-disabled="Off"
                class="mx-3"
              ></switches>
            </div>
            <div class="screens-container">
              <div class="mobile my-4">
                <img
                  src="@/assets/images/mobile-header.png"
                  alt
                  style="margin: 5px 0"
                />
                <div class="search px-2">
                  <img src="@/assets/images/search.svg" alt />
                  <span class="pl-2" style="font-size: 10px">Search</span>
                </div>
                <div
                  v-if="featureBanner.feature_banner.app_image"
                  class="banner-image my-4"
                >
                  <div
                    class="guide d-none"
                    style="margin: -8px; position: absolute"
                    :class="{ 'd-block': guides }"
                  >
                    A
                  </div>
                  <div style="text-align:center"><b-img :src="appbannerpreview" fluid style="height:92px" /></div>
                </div>
                <div
                  v-else
                  class="banner-image my-4"
                >
                  <div
                    class="guide d-none"
                    style="margin: -8px; position: absolute"
                    :class="{ 'd-block': guides }"
                  >
                    A
                  </div>
                  <div style="text-align:center"><b-img :src="appbannerpreview" fluid style="height:92px" /></div>
                </div>
                <span class="d-block" style="text-align: left"
                  >What's nearby</span
                >
                <img src="@/assets/images/store.png" alt class="my-2" />
                <img src="@/assets/images/mobile-nav.png" alt class="my-2" />
              </div>
              <div class="web my-4">
                <div
                  class="header"
                  style="
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    height: 40px;
                  "
                >
                  <span style="font-family: MainFontBold, sans-serif; font-weight: normal; font-size: 10px"
                    >Company Logo</span
                  >
                  <div
                    style="height: 20px; width: 80px; background: #ff8828; border-radius: 20px; display: flex; align-items; center; justify-content: center;"
                  >
                    <span style="color: #fff; font-size: 12px">Sign in</span>
                  </div>
                </div>
                <div
                  v-if="featureBanner.feature_banner.web_image"
                  class="banner-image mt-2"
                  style="overflow:hidden"
                >
                  <div
                    class="guide d-none"
                    style="margin: 5px; position: absolute"
                    :class="{ 'd-block': guides }"
                  >
                    B
                  </div>
                  <div style="text-align:center"><b-img :src="webbannerpreview" fluid style="height:230px"/></div>
                </div>
                <div
                  v-else
                  class="banner-image mt-2"
                  :style="{ backgroundImage: 'url(' + webBanner + ')' }"
                >
                  <div
                    class="guide d-none"
                    style="margin: 5px"
                    :class="{ 'd-block': guides }"
                  >
                    B
                  </div>
                  <img
                    src="@/assets/images/image-icon.svg"
                    alt
                    style="display: block; margin: 80px auto"
                    v-if="!webBanner"
                  />
                </div>
              </div>
              <div class="glife my-4">
                <div
                  class="guide d-none"
                  style="top: 170px; left: 30px; position: absolute; z-index: 2"
                  :class="{ 'd-block': guides }"
                >
                  C
                </div>
                <div
                  class="banner-image my-4"
                >
                <div style="text-align:center"><b-img :src="glifebannerpreview" fluid style="height:92px" /></div>
                </div>
                  <img
                    src="@/assets/images/image-icon.svg"
                    alt
                    style="display: block; margin: 35px auto"
                  />
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col md="4">
          <div class="right-sidebar p-3" v-if="featureBanner">
            <b-form-group class="mt-1 secondary-label">
              <template #label>
                Title <span class="text-danger font-weight-bold">*</span>
              </template>
              <b-form-input
                ref="title"
                placeholder="Enter title"
                v-model="featureBanner.feature_banner.title"
              ></b-form-input>
              <div class="text-danger" v-if="titleError">
                {{ titleError }}
              </div>
            </b-form-group>
            <div class="app-banner">
              <div class="label my-2" style="display: flex">
                <div class="guide">A</div>
                <span class="ml-2 mr-1">APP BANNER IMAGE</span>
                <span
                  v-if="isAppChannelEnabled"
                  class="text-danger font-weight-bold"
                >
                  *
                </span>
                <span  v-if="appbannerpreview" class="previewremoveappbanner" v-b-modal="'delete-modal-app-banner'">
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" class="icon icon-remove" style="top: -7.5px; right: -5px;">
                    <path d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z" fill="#ff8828">
                  </path>
                  </svg>
              </span>
                <b-modal id="delete-modal-app-banner" title="Delete App Banner Image">
                    <p class="modal-main-message">Are you sure you want delete this App Banner Image?</p>
                    <div slot="modal-footer">
                        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal-app-banner')">
                            Cancel
                        </b-btn>
                        <b-btn variant="primary" class="ml-1" @click="removeImage('app-banner')">
                            Yes, Delete
                        </b-btn>
                    </div>
                </b-modal>
              </div>
              <div
                class="upload-banner"
                v-if="featureBanner.feature_banner.app_image"
                style="overflow:hidden"
              >
                <div><b-img :src="appbannerpreview" fluid /></div>
                <input
                  type="file"
                  name="image"
                  ref="appBanner"
                  style="opacity: 0"
                  @change="inputAppBanner"
                />
                <b-button
                  class="img-icon border-0"
                  :disabled="!isAppChannelEnabled"
                  v-b-modal.uploadAppBanner
                >
                  <img src="@/assets/images/camera.svg" alt="Camera" />
                </b-button>
              </div>
              <div
                v-else
                class="upload-banner"
                :style="{ backgroundImage: 'url(' + appBanner + ')' }"
              >
                <div><b-img :src="appbannerpreview" fluid /></div>
                <input
                  type="file"
                  name="image"
                  ref="appBanner"
                  style="opacity: 0"
                  @change="inputAppBanner"
                />
                <b-button
                  class="img-icon border-0"
                  :disabled="!isAppChannelEnabled"
                  v-b-modal.uploadAppBanner
                >
                  <img src="@/assets/images/camera.svg" alt="Camera" />
                </b-button>
              </div>
              <div v-show="appImageError" class="text-danger">
                {{ appImageError }}
              </div>
              <span style="display: block">Required Size: 335px x 140px</span>
              <b-modal id="uploadAppBanner" title="Upload App Banner" no-close-on-backdrop no-close-on-esc>
                <div id="app-banner-container" class="border mx-auto">
                    <croppa
                        v-model="myAppBannerCroppa"
                        @new-image-drawn="onNewAppBannerImage"
                        @zoom="onAppBannerZoom"
                        :width="335"
                        :height="140"
                        placeholder="Choose an image"
                        :show-remove-button="true"
                        :placeholder-font-size="14"
                        remove-button-color="#ff8828">
                    </croppa>
                </div>
                <div id="app-banner-image-range-container" class="mx-auto mt-2">
                    <input type="range" class="custom-range" id="customRangelogo" @input="onAppBannerSliderChange" :min="sliderAppBannerMin" :max="sliderAppBannerMax" step=".001" v-model="sliderAppBannerVal">
                </div>
                <div slot="modal-footer">
                    <b-button variant="secondary" @click="cancelUploadAppBanner" style="margin-right: .25rem;">
                        Cancel
                    </b-button>
                    <b-button variant="primary" @click="saveUploadAppBanner" style="margin-left: .25rem;">
                        Save
                    </b-button>
                </div>
              </b-modal>
              <switches
                v-model="featureBanner.feature_banner.app_image_show"
                theme="custom"
                color="primary"
                type-bold="true"
                text-enabled="On"
                text-disabled="Off"
                :disabled="!isAppChannelEnabled"
              ></switches>
            </div>
            <div class="web-banner">
              <div class="label my-2" style="display: flex">
                <div class="guide">B</div>
                <span class="ml-2 mr-1">WEB BANNER IMAGE</span>
                <span
                  v-if="isWebChannelEnabled"
                  class="text-danger font-weight-bold"
                >
                  *
                </span>
                <span  v-if="webbannerpreview" class="previewremovewebbanner" v-b-modal="'delete-modal-web-banner'">
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" class="icon icon-remove" style="top: -7.5px; right: -5px;">
                    <path d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z" fill="#ff8828">
                  </path>
                  </svg>
                </span>
                <b-modal id="delete-modal-web-banner" title="Delete Web Banner Image">
                    <p class="modal-main-message">Are you sure you want delete this Web Banner Image?</p>
                    <div slot="modal-footer">
                        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal-web-banner')">
                            Cancel
                        </b-btn>
                        <b-btn variant="primary" class="ml-1" @click="removeImage('web-banner')">
                            Yes, Delete
                        </b-btn>
                    </div>
                </b-modal>
              </div>
              <div
                class="upload-banner"
                v-if="featureBanner.feature_banner.web_image"
                style="height:109px; overflow:hidden"
              >
                <div><b-img :src="webbannerpreview" fluid /></div>
                <input
                  type="file"
                  name="image"
                  ref="webBanner"
                  style="opacity: 0"
                  @change="inputWebBanner"
                />
                <b-button
                  class="img-icon border-0"
                  :disabled="!isWebChannelEnabled"
                  v-b-modal.uploadWebBanner
                >
                  <img src="@/assets/images/camera.svg" alt="Camera" />
                </b-button>
              </div>
              <div
                v-else
                class="upload-banner"
                style="height:109px; overflow:hidden"
              >
                <div><b-img :src="webbannerpreview" fluid /></div>
                <input
                  type="file"
                  name="image"
                  ref="webBanner"
                  style="opacity: 0"
                  @change="inputWebBanner"
                />
                <b-button
                  class="img-icon border-0"
                  :disabled="!isWebChannelEnabled"
                  v-b-modal.uploadWebBanner
                >
                  <img src="@/assets/images/camera.svg" alt="Camera" />
                </b-button>
              </div>
              <div v-show="webImageError" class="text-danger">
                {{ webImageError }}
              </div>
              <span style="display: block">Required Size: 1440px x 465px</span>
              <b-modal id="uploadWebBanner" title="Upload Web Banner" no-close-on-backdrop no-close-on-esc>
                <div id="web-banner-container" class="border mx-auto">
                    <croppa
                        v-model="myWebBannerCroppa"
                        @new-image-drawn="onNewWebBannerImage"
                        @zoom="onWebBannerZoom"
                        :width="720"
                        :height="232"
                        placeholder="Choose an image"
                        :show-remove-button="true"
                        :placeholder-font-size="14"
                        remove-button-color="#ff8828">
                    </croppa>
                </div>
                <div id="web-banner-image-range-container" class="mx-auto mt-2">
                    <input type="range" class="custom-range" id="customRangelogo" @input="onWebBannerSliderChange" :min="sliderWebBannerMin" :max="sliderWebBannerMax" step=".001" v-model="sliderWebBannerVal">
                </div>
                <div slot="modal-footer">
                    <b-button variant="secondary" @click="cancelUploadWebBanner" style="margin-right: .25rem;">
                        Cancel
                    </b-button>
                    <b-button variant="primary" @click="saveUploadWebBanner" style="margin-left: .25rem;">
                        Save
                    </b-button>
                </div>
              </b-modal>
              <switches
                v-model="featureBanner.feature_banner.web_image_show"
                theme="custom"
                color="primary"
                type-bold="true"
                text-enabled="On"
                text-disabled="Off"
                :disabled="!isWebChannelEnabled"
              ></switches>
            </div>
            <div>
              <div class="label my-2" style="display: flex">
                <div class="guide">C</div>
                <span class="ml-2 mr-1">GLIFE BANNER IMAGE</span>
                <span
                  v-if="isGLifeChannelEnabled"
                  class="text-danger font-weight-bold"
                >
                  *
                </span>
                <span  v-if="glifebannerpreview" class="previewremoveglifebanner" v-b-modal="'delete-modal-glife-banner'">
                  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" class="icon icon-remove" style="top: -7.5px; right: -5px;">
                    <path d="M511.921231 0C229.179077 0 0 229.257846 0 512 0 794.702769 229.179077 1024 511.921231 1024 794.781538 1024 1024 794.702769 1024 512 1024 229.257846 794.781538 0 511.921231 0ZM732.041846 650.633846 650.515692 732.081231C650.515692 732.081231 521.491692 593.683692 511.881846 593.683692 502.429538 593.683692 373.366154 732.081231 373.366154 732.081231L291.761231 650.633846C291.761231 650.633846 430.316308 523.500308 430.316308 512.196923 430.316308 500.696615 291.761231 373.523692 291.761231 373.523692L373.366154 291.918769C373.366154 291.918769 503.453538 430.395077 511.881846 430.395077 520.349538 430.395077 650.515692 291.918769 650.515692 291.918769L732.041846 373.523692C732.041846 373.523692 593.447385 502.547692 593.447385 512.196923 593.447385 521.412923 732.041846 650.633846 732.041846 650.633846Z" fill="#ff8828">
                  </path>
                  </svg>
                </span>
                <b-modal id="delete-modal-glife-banner" title="Delete Glife Banner Image">
                    <p class="modal-main-message">Are you sure you want delete this Glife`` Banner Image?</p>
                    <div slot="modal-footer">
                        <b-btn variant="ghost" class="mr-1 btn-cancel" @click="hideModal('delete-modal-glife-banner')">
                            Cancel
                        </b-btn>
                        <b-btn variant="primary" class="ml-1" @click="removeImage('glife-banner')">
                            Yes, Delete
                        </b-btn>
                    </div>
                </b-modal>
              </div>
              <div
                class="upload-banner"
                v-if="featureBanner.feature_banner.gcash_image"
                style="overflow:hidden"
              >
                <div><b-img :src="glifebannerpreview" fluid /></div>
                <input
                  type="file"
                  name="image"
                  ref="glifeBanner"
                  style="opacity: 0"
                  @change="inputGlifeBanner"
                />
                <b-button
                  class="img-icon border-0"
                  :disabled="!isGLifeChannelEnabled"
                  v-b-modal.uploadGlifeBanner
                >
                  <img src="@/assets/images/camera.svg" alt="Camera" />
                </b-button>
              </div>
              <div
                v-else
                class="upload-banner"
              >
                <div><b-img :src="glifebannerpreview" fluid /></div>
                <input
                  type="file"
                  name="image"
                  ref="glifeBanner"
                  style="opacity: 0"
                  @change="inputGlifeBanner"
                />
                <b-button
                  class="img-icon border-0"
                  :disabled="!isGLifeChannelEnabled"
                  v-b-modal.uploadGlifeBanner
                >
                  <img src="@/assets/images/camera.svg" alt="Camera" />
                </b-button>
              </div>
              <div v-show="glifeImageError" class="text-danger">
                {{ glifeImageError }}
              </div>
              <span style="display: block">Required Size: 335px x 140px</span>
              <b-modal id="uploadGlifeBanner" title="Upload Glife Banner" no-close-on-backdrop no-close-on-esc>
                <div id="glife-banner-container" class="border mx-auto">
                    <croppa
                        v-model="myGlifeBannerCroppa"
                        @new-image-drawn="onNewGlifeBannerImage"
                        @zoom="onGlifeBannerZoom"
                        :width="335"
                        :height="140"
                        placeholder="Choose an image"
                        :show-remove-button="true"
                        :placeholder-font-size="14"
                        remove-button-color="#ff8828">
                    </croppa>
                </div>
                <div id="glife-banner-image-range-container" class="mx-auto mt-2">
                    <input type="range" class="custom-range" id="customRangelogo" @input="onGlifeBannerSliderChange" :min="sliderGlifeBannerMin" :max="sliderGlifeBannerMax" step=".001" v-model="sliderGlifeBannerVal">
                </div>
                <div slot="modal-footer">
                    <b-button variant="secondary" @click="cancelUploadGlifeBanner" style="margin-right: .25rem;">
                        Cancel
                    </b-button>
                    <b-button variant="primary" @click="saveUploadGlifeBanner" style="margin-left: .25rem;">
                        Save
                    </b-button>
                </div>
              </b-modal>
              <switches
                v-model="featureBanner.feature_banner.gcash_image_show"
                theme="custom"
                color="primary"
                type-bold="true"
                text-enabled="On"
                text-disabled="Off"
                :disabled="!isGLifeChannelEnabled"
              ></switches>
            </div>
            <b-form-group class="mb-1">
              <label class="secondary-label align-top">
                Publish Date <span class="text-danger font-weight-bold">*</span>
              </label>
              <div class="custom-datepicker mb-3 muli-sb">
                <SingleDatepicker
                  :bootstrap-styling="true"
                  :value="featureBanner.feature_banner.published_date"
                  ref="publishProgrammaticOpen"
                  v-model="featureBanner.feature_banner.published_date"
                  wrapper-class="custom-datepicker"
                  style="color: #2a2a2a !important"
                  placeholder="Select date"
                  format="MMM dd, yyyy"
                  :disabled-dates="{ to: dateYesterday }"
                >
                  <div slot="afterDateInput" class="input-group-append pr-0">
                    <span class="input-group-text">
                      <img
                        @click="openPublishPicker"
                        src="@/assets/images/icons/calendar.svg"
                        alt="Calendar Icon"
                        class="form-icon action-button"
                      />
                    </span>
                  </div>
                </SingleDatepicker>
                <div
                  class="text-danger"
                  v-if="errors && errors.errors.published_date"
                >
                  {{ defaultInvalidDateError }}
                </div>
              </div>
            </b-form-group>
            <b-form-group class="mb-1">
              <label class="secondary-label align-top">
                Duration <span class="text-danger font-weight-bold">*</span>
              </label>
              <div style="display: flex">
                <datepicker
                  :config="dateRangeConfig"
                  placeholder="Select date"
                  v-model="newDuration"
                  :value="newDuration"
                ></datepicker>
                <div slot="afterDateInput" class="input-group-append pr-0">
                  <span class="input-group-text">
                    <img
                      @click="openRangePicker"
                      src="@/assets/images/icons/calendar.svg"
                      alt="Calendar Icon"
                      class="form-icon action-button"
                    />
                  </span>
                </div>
              </div>
              <div
                class="text-danger"
                v-if="errors && errors.errors.start_date"
              >
                {{ defaultInvalidDateError }}
              </div>
            </b-form-group>
            <b-form-group label="URL Link" class="mt-3 secondary-label">
              <input
                class="form-control"
                name="url"
                id="url"
                v-model="featureBanner.feature_banner.url_link"
                placeholder="https://example.com"
              />
              <div class="text-danger" v-if="errors && errors.errors.url_link">
                {{ errors.errors.url_link }}
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>

<script>
import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";
import { mapState, mapGetters } from "vuex";
import notification from "@/services/notification";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState("designs", {
      loading: state => state.loading, 
      featureBanner: state => state.featureBanner,
      errors: state => state.errors, 
      form(state) {
          if (!this.uuid) {
              this.myAppBannerB64 = null;
              return {
                  name: "Design name",
                  appbanner: null,
                  background_image: null,
                  color: "#EBECF0",
                  button_color: "#FF8828",
                  font_color: "#FFFFFF",
                  dark_mode: 0
              };
          }
          return state.details;
      },
      appbannerpreview(state) {
          let _preview = null;

          if (this.featureBanner) {
              _preview = state.featureBanner.feature_banner.app_image
          }

          if (this.myAppBannerB64) {
              _preview = "data:image/png;base64," + this.myAppBannerB64;
          }

          return _preview;
      },
      webbannerpreview(state) {
          let _preview = null;

          if (this.featureBanner) {
              _preview = state.featureBanner.feature_banner.web_image
          }

          if (this.myWebBannerB64) {
              _preview = "data:image/png;base64," + this.myWebBannerB64;
          }

          return _preview;
      },
      glifebannerpreview(state) {
          let _preview = null;

          if (this.featureBanner) {
              _preview = state.featureBanner.feature_banner.gcash_image
          }

          if (this.myGlifeBannerB64) {
              _preview = "data:image/png;base64," + this.myGlifeBannerB64;
          }

          return _preview;
      },
    }),
    ...mapGetters("accountProfile", [
      "planDetails",
      "isWebChannelEnabled",
      "isAppChannelEnabled",
      "isGLifeChannelEnabled",
    ]),
    dateRangeConfig: {
      get: function () {
        let _this = this;
        return {
          altInput: true,
          altFormat: "M j, Y",
          dateFormat: "Y-m-d",
          static: true,
          mode: "range",
          onChange: function (selectedDates) {
            _this.selectedDate(selectedDates);
            _this.range = selectedDates;
          },
          onReady: function (selectedDates, dateStr, instance) {
            _this.rangePicker = instance;
          },
        };
      },
    },
  },
  components: {
    Datepicker,
    SingleDatepicker,
    Switches,
  },
  created() {
    this.viewFeatureBanner(this.id);
  },
  data() {
    return {
      guides: true,
      duration: "",
      appBanner: null,
      webBanner: null,
      glifeBanner: null,
      newDuration: "",
      titleError: "",
      appImageError: "",
      webImageError: "",
      glifeImageError: "",
      dateToday: new Date(),
      dateYesterday: new Date(new Date().valueOf() - 1000 * 60 * 60 * 24),
      defaultInvalidDateError: "Please enter a valid date.",
      myAppBannerB64: null,
      myAppBannerCroppa: {},
      sliderAppBannerVal: 0,
      sliderAppBannerMin: 0,
      sliderAppBannerMax: 0,
      myWebBannerB64: null,
      myWebBannerCroppa: {},
      sliderWebBannerVal: 0,
      sliderWebBannerMin: 0,
      sliderWebBannerMax: 0,
      myGlifeBannerB64: null,
      myGlifeBannerCroppa: {},
      sliderGlifeBannerVal: 0,
      sliderGlifeBannerMin: 0,
      sliderGlifeBannerMax: 0,
    };
  },
  methods: {
    removeImage(type) {
        if (type == "app-banner") {
            this.myAppBannerB64 = null;
            this.featureBanner.feature_banner.app_image = null;
            this.myAppBannerCroppa.remove();
            this.hideModal("delete-modal-app-banner");
        } else if (type == 'web-banner') {
            this.myWebBannerB64 = null;
            this.featureBanner.feature_banner.web_image = null;
            this.myWebBannerCroppa.remove();
            this.hideModal("delete-modal-web-banner");
        }  else if (type == 'glife-banner') {
            this.myGlifeBannerB64 = null;
            this.myGlifeBannerCroppa.remove();
            this.featureBanner.feature_banner.gcash_image = null;
            this.hideModal("delete-modal-glife-banner");
        }
    },
    hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
    },
    deleteBanner(type) {
      switch (type) {
        case "appBanner":
          this.featureBanner.feature_banner.app_image = null;
          break;
        case "webBanner":
          this.featureBanner.feature_banner.web_image = null;
          break;
        case "glifeBanner":
          this.featureBanner.feature_banner.gcash_image = null;
          break;
        default:
          break;
      }
    },
    formatDuration() {
      this.newDuration =
        this.featureBanner.feature_banner.start_date +
        " to " +
        this.featureBanner.feature_banner.end_date;
    },
    async viewFeatureBanner(id) {
      let uuid = id;
      await this.$store.dispatch("designs/viewFeatureBanner", uuid).then(() => {
        this.formatDuration();
      });
    },
    customFormatter(date) {
      return moment(date).format("MMMM Do YYYY");
    },
    inputAppBanner(e) {
      let file = e.target.files[0];
      this.addBanner(file, "appBanner");
    },
    inputWebBanner(e) {
      let file = e.target.files[0];
      this.addBanner(file, "webBanner");
    },
    inputGlifeBanner(e) {
      let file = e.target.files[0];
      this.addBanner(file, "glifeBanner");
    },
    addBanner(file, bannerType) {
      if (!file.type.match("image.*")) {
        alert("File not supported.");
        return;
      }

      let reader = new FileReader();

      reader.readAsDataURL(file);

      if (bannerType === "appBanner") {
        reader.onload = (e) => {
          this.appBanner = e.target.result;
          this.featureBanner.feature_banner.app_image = e.target.result;
        };
      }

      if (bannerType === "webBanner") {
        reader.onload = (e) => {
          this.webBanner = e.target.result;
          this.featureBanner.feature_banner.web_image = e.target.result;
        };
      }

      if (bannerType === "glifeBanner") {
        reader.onload = (e) => {
          this.glifeBanner = e.target.result;
          this.featureBanner.feature_banner.gcash_image = e.target.result;
        };
      }
    },
    openPublishPicker() {
      this.$refs.publishProgrammaticOpen.showCalendar();
    },
    openRangePicker() {
      if (this.rangePicker) {
        this.rangePicker.toggle();
      }
    },
    selectedDate(selectedDate) {
      this.duration = selectedDate;
    },
    async updateDesign(origin) {
      this.titleError = "";
      this.appImageError = "";
      this.webImageError = "";
      this.glifeImageError = "";

      this.$store.commit("designs/errors", null);

      if (!this.featureBanner.feature_banner.title)
        this.titleError = "Title is required.";

      if (
        this.isAppChannelEnabled &&
        this.featureBanner.feature_banner.app_image_show &&
        !this.featureBanner.feature_banner.app_image
      )
        this.appImageError = "App Banner Image is required.";

      if (
        this.isWebChannelEnabled &&
        this.featureBanner.feature_banner.web_image_show &&
        !this.featureBanner.feature_banner.web_image
      )
        this.webImageError = "Web Banner Image is required.";

      if (
        this.isGLifeChannelEnabled &&
        this.featureBanner.feature_banner.gcash_image_show &&
        !this.featureBanner.feature_banner.gcash_image
      )
        this.glifeImageError = "GLife Banner Image is required.";

      if (
        !this.featureBanner.feature_banner.app_image_show &&
        !this.featureBanner.feature_banner.web_image_show &&
        !this.featureBanner.feature_banner.gcash_image_show
      ) {
        notification.warning(
          "Please enable at least one channel for E-Store Banner."
        );
        return;
      }

      if (
        this.titleError ||
        this.appImageError ||
        this.webImageError ||
        this.glifeImageError
      ) {
        notification.warning("Oops, cannot save banner.");
        return;
      }

      let newAppBanner;
      let newWebBanner;
      let newGlifeBanner;

      if (this.appBanner) {
        newAppBanner = this.appBanner.split("base64,").pop();
        this.appImageError = "";
      }

      if (this.webBanner) {
        newWebBanner = this.webBanner.split("base64,").pop();
        this.webImageError = "";
      }

      if (this.glifeBanner) {
        newGlifeBanner = this.glifeBanner.split("base64,").pop();
        this.glifeImageError = "";
      }

      let currentDate = new Date();
      let validatedPublishedDate =
        this.featureBanner.feature_banner.published_date;

      if (
        this.featureBanner.feature_banner.published_date >=
        currentDate.setDate(currentDate.getDate() - 1)
      ) {
        validatedPublishedDate = this.$moment(
          this.featureBanner.feature_banner.published_date
        ).format("YYYY-MM-DD");
      }

      let validatedStartDate = this.featureBanner.feature_banner.start_date;
      let validatedEndDate = this.featureBanner.feature_banner.end_date;
      if (this.duration.length) {
        validatedStartDate = this.$moment(this.duration[0]).format(
          "YYYY-MM-DD"
        );
        if (validatedStartDate >= validatedPublishedDate) {
          validatedStartDate = this.$moment(this.duration[0]).format(
            "YYYY-MM-DD"
          );
          validatedEndDate = this.$moment(this.duration[1]).format(
            "YYYY-MM-DD"
          );
        }
      }

      let param = {
        uuid: this.featureBanner.feature_banner.uuid,
        title: this.featureBanner.feature_banner.title,
        app_image: newAppBanner,
        app_image_show: this.featureBanner.feature_banner.app_image_show,
        web_image: newWebBanner,
        web_image_show: this.featureBanner.feature_banner.web_image_show,
        gcash_image: newGlifeBanner,
        gcash_image_show: this.featureBanner.feature_banner.gcash_image_show,
        published_date: validatedPublishedDate,
        published: origin !== "draft",
        start_date: validatedStartDate,
        end_date: validatedEndDate,
        url_link: this.featureBanner.feature_banner.url_link,
      };
      let _this = this;
      await this.$store
        .dispatch("designs/updateFeatureBanner", param)
        .then(() => {
          if (!this.errors) _this.$router.push({ name: "estorebanner" });
        });
    },
    validateURL(url) {
      let pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
          "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
          "((\\d{1,3}\\.){3}\\d{1,3}))" + // ip (v4) address
          "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + //port
          "(\\?[;&amp;a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return pattern.test(url);
    },

    // APP BANNER  CROPPA
    onAppBannerZoom() {
        this.sliderAppBannerVal = this.myAppBannerCroppa.scaleRatio;
    },
    onNewAppBannerImage() {
        this.sliderAppBannerVal = this.myAppBannerCroppa.scaleRatio;
        this.sliderAppBannerMin = this.myAppBannerCroppa.scaleRatio / 2;
        this.sliderAppBannerMax = this.myAppBannerCroppa.scaleRatio * 2;
    },
    onAppBannerSliderChange(evt) {
        var increment = evt.target.value;
        this.myAppBannerCroppa.scaleRatio = +increment;
    },
    cancelUploadAppBanner() {
        this.$root.$emit("bv::hide::modal", "uploadAppBanner");
    },
    saveUploadAppBanner() {
        let _base64 = this.myAppBannerCroppa.generateDataUrl() || null;
        if (!_base64) {
            return;
        }

        let _img64 = _base64.replace(/data:image\/png;base64,/gi, "");
        this.appBanner = _img64;
        this.featureBanner.feature_banner.app_image = _img64;
        this.myAppBannerB64 = _img64;
        this.cancelUploadAppBanner();
    },

    // WEB BANNER  CROPPA
    onWebBannerZoom() {
        this.sliderWebBannerVal = this.myWebBannerCroppa.scaleRatio;
    },
    onNewWebBannerImage() {
        this.sliderWebBannerVal = this.myWebBannerCroppa.scaleRatio;
        this.sliderWebBannerMin = this.myWebBannerCroppa.scaleRatio / 2;
        this.sliderWebBannerMax = this.myWebBannerCroppa.scaleRatio * 2;
    },
    onWebBannerSliderChange(evt) {
        var increment = evt.target.value;
        this.myWebBannerCroppa.scaleRatio = +increment;
    },
    cancelUploadWebBanner() {
        this.$root.$emit("bv::hide::modal", "uploadWebBanner");
    },
    saveUploadWebBanner() {
        let _base64 = this.myWebBannerCroppa.generateDataUrl() || null;
        if (!_base64) {
            return;
        }

        let _img64 = _base64.replace(/data:image\/png;base64,/gi, "");
        this.webBanner = _img64;
        this.featureBanner.feature_banner.web_image = _img64;
        this.myWebBannerB64 = _img64;
        this.cancelUploadWebBanner();
    },

    // GLIFE BANNER  CROPPA
    onGlifeBannerZoom() {
        this.sliderGlifeBannerVal = this.myGlifeBannerCroppa.scaleRatio;
    },
    onNewGlifeBannerImage() {
        this.sliderGlifeBannerVal = this.myGlifeBannerCroppa.scaleRatio;
        this.sliderGlifeBannerMin = this.myGlifeBannerCroppa.scaleRatio / 2;
        this.sliderGlifeBannerMax = this.myGlifeBannerCroppa.scaleRatio * 2;
    },
    onGlifeBannerSliderChange(evt) {
        var increment = evt.target.value;
        this.myGlifeBannerCroppa.scaleRatio = +increment;
    },
    cancelUploadGlifeBanner() {
        this.$root.$emit("bv::hide::modal", "uploadGlifeBanner");
    },
    saveUploadGlifeBanner() {
        let _base64 = this.myGlifeBannerCroppa.generateDataUrl() || null;
        if (!_base64) {
            return;
        }

        let _img64 = _base64.replace(/data:image\/png;base64,/gi, "");
        this.glifeBanner = _img64;
        this.featureBanner.feature_banner.gcash_image = _img64;
        this.myGlifeBannerB64 = _img64;
        this.cancelUploadGlifeBanner();
    },
  },
};
</script>

<style lang="scss" scoped>
.image-upload {
  width: 335px;
  height: 140px;
  background: #f7f8fb;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  background: #ffffff
      url("../../../assets/images/achievement/default-image.svg") no-repeat
      center;
  img.image {
      width: 128px;
      height: 66px;
      border-radius: 5px;
  }

  span.img-icon {
      box-shadow: 0 0 3px #ccc, inset 0 0 3px #b8b8b8;
      padding: 2px;
      border-radius: 12.5px;
      position: absolute;
      width: 25px;
      height: 25px;
      text-align: center;
      bottom: 40px;
      left: 170px;
  }

  #app-banner-container {
    width: 336px;
    height: 141px;
    background-color: #f3f3f4;
    cursor: pointer;
  }

  #web-banner-container {
    width: 820px;
    height: 232px;
    background-color: #f3f3f4;
    cursor: pointer;
  }

  #glife-banner-container {
    width: 336px;
    height: 141px;
    background-color: #f3f3f4;
    cursor: pointer;
  }
}
</style>

<style>
#app-banner-container {
  width: 336px;
  height: 141px;
  background-color: #f3f3f4;
  cursor: pointer;
}

#app-banner-container svg.icon-remove {
  top: -160px !important;
  right: unset !important;
  left: 322px !important;
  position: relative;
}

#uploadWebBanner .modal-content {
  width: 820px;
  height: auto;
}

#uploadWebBanner .modal-dialog {
  max-width: 720px;
  height: 232px;
}

#web-banner-container {
  width: 720px;
  height: 232px;
  background-color: #f3f3f4;
  cursor: pointer;
}

#web-banner-container svg.icon-remove {
  top: -250px !important;
  right: unset !important;
  left: 707px !important;
  position: relative;
}

#glife-banner-container {
  width: 336px;
  height: 141px;
  background-color: #f3f3f4;
  cursor: pointer;
}

#glife-banner-container svg.icon-remove {
  top: -160px !important;
  right: unset !important;
  left: 322px !important;
  position: relative;
}

span.previewremoveappbanner {
  top: 120px;
  left: 337px;
  z-index: 9;
  position: absolute;
}

span.previewremovewebbanner {
  top: 385px;
  left: 337px;
  z-index: 9;
  position: absolute;
}

span.previewremoveglifebanner {
  top: 620px;
  left: 337px;
  z-index: 9;
  position: absolute;
}
</style>